module.exports = __webpack_public_path__ + "img/hoermann-logo-white.dbcc9a00.svg";